'use client';

import ShowMoreText, {
    type ReactShowMoreTextProps,
} from 'react-show-more-text';

interface ShowMoreProps extends ReactShowMoreTextProps {
    showMoreLabel?: string;
    showLessLabel?: string;
}

export default function ShowMore({
    children,
    lines = 1,
    showMoreLabel = 'Rozwiń',
    showLessLabel = 'Zwiń',
    ...props
}: ShowMoreProps) {
    return (
        <ShowMoreText
            lines={lines}
            more={
                <span className="cursor-pointer text-green-600">
                    {showMoreLabel}
                </span>
            }
            less={
                <span className="cursor-pointer text-green-600">
                    {showLessLabel}
                </span>
            }
            {...props}
        >
            {children}
        </ShowMoreText>
    );
}
